<template>
  <div class='container' :class="{ isTiny: isTiny }">
    <div class="mobile-warning" v-if="isTiny">
      <p>
        Image Zoomer only works on desktop because the developer had enough to figure out without
        adding touch events into the mix. If he rebuilds this, he will rebuild it for mobile as well
        as desktop.
      </p>
    </div>
    <div class='home' v-if="!isTiny">
      <div class='home__content'>
        <h1>Image Zoomer</h1>

        <h2>Highlight your favourite dog in a picture of some dogs!</h2>
        <div class="example">
          <div class="example-from">
            <img class="responsive" src="../assets/example-dogs.jpg">
          </div>
          <div class="example-transition">
            <svg class="icon-transition" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 40">
              <path d="m 44.00002,19.99475 c -0.028,-0.715 -0.3223,-1.5414 -0.8125,-2.0626 l -16,
              -17.00076 c -1.0842,-0.9743 -3.16322,-1.3765 -4.37502,-0.25 -1.1936,1.1095 -1.1581,
              3.2613 0.031,4.3752 l 11.25002,11.9381 H 3 c -1.6568,0 -3,1.34316 -3,
              3.00006 0,1.6569 1.3432,3.0001 3,3.0001 H 34.09352 L 22.8435,34.93295 c -1.0237,
              1.0255 -1.2129,3.253 -0.031,4.3752 1.1816,1.1221 3.33532,0.7636 4.37502,-0.2501 l 16,
              -17.0007 c 0.5475,-0.5818 0.8143,-1.2644 0.8125,-2.0626 z" />
            </svg>
          </div>
          <div class="example-to">
            <img class="responsive" src="../assets/example-dogs-output.jpg" alt="">
          </div>
        </div>

        <h2>Mock someone for their poor typing skills!</h2>
        <div class="example">
          <div class="example-from">
            <img class="responsive" src="../assets/example-chat.png">
          </div>
          <div class="example-transition">
            <svg class="icon-transition" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 40">
              <path d="m 44.00002,19.99475 c -0.028,-0.715 -0.3223,-1.5414 -0.8125,-2.0626 l -16,
              -17.00076 c -1.0842,-0.9743 -3.16322,-1.3765 -4.37502,-0.25 -1.1936,1.1095 -1.1581,
              3.2613 0.031,4.3752 l 11.25002,11.9381 H 3 c -1.6568,0 -3,1.34316 -3,
              3.00006 0,1.6569 1.3432,3.0001 3,3.0001 H 34.09352 L 22.8435,34.93295 c -1.0237,
              1.0255 -1.2129,3.253 -0.031,4.3752 1.1816,1.1221 3.33532,0.7636 4.37502,-0.2501 l 16,
              -17.0007 c 0.5475,-0.5818 0.8143,-1.2644 0.8125,-2.0626 z" />
            </svg>
          </div>
          <div class="example-to">
            <img class="responsive" src="../assets/example-chat-output.png" alt="">
          </div>
        </div>
      </div>
      <div class='home__sidebar'>
        <div class='hover-box'>
          <ImageUpload/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from '../components/ImageUpload.vue';

export default {
  name: 'Home',
  components: { ImageUpload },
  data() {
    return {
      isTiny: false,
    };
  },
  mounted() {
    if (window.innerWidth < 1000) {
      this.isTiny = true;
    }
  },
};
</script>

<style scoped lang='scss'>
  @import '../styles/variables';

  .container.isTiny {
    max-width: 100%;
  }

  .home {
    display: flex;
    height: 100%;
  }

  .home__content {
    padding: $spacing;
    width: 100%;
  }

  .home__sidebar {
    padding: $spacing $spacing $spacing * 2;
    flex-shrink: 0;
    width: 300px;
    height: 100%;
  }

  .hover-box {
    width: 100%;
    height: 100%;
    border: 2px solid #000000;
    box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  }

  .example {
    display: flex;
    margin-top: $spacing;
    margin-bottom: $spacing;
  }

  .example-from {
    width: 240px;
  }

  .example-transition {
    margin: auto;
  }

  .example-to {
    width: 200px;
  }

  .icon-transition {
    width: 44px;
    height: auto;
  }

  ul {
    margin-left: $spacing;
  }
</style>
